import type { AxiosRequestConfig } from 'axios'

import type { TUnidadesDeNegocioDisponiveisResponse } from '@/features/regionais/interfaces/unidade-de-negocio.types'
import { HttpService } from '@/shared/lib'

export class GetUnidadeDeNegocioService extends HttpService {
  execute = async () => {
    return this.http.get<TUnidadesDeNegocioDisponiveisResponse, AxiosRequestConfig>(
      `api/v2/UnidadeDeNegocio/disponiveis`,
    )
  }
}
